enum ModeReglement {
  CARTE = "Carte",
  CHEQUE = "Chèque",
  VIREMENT = "Virement",
  ESPECE = "Espèce",
}

export default ModeReglement